import { NgModule } from "@angular/core";
import { IonicPageModule } from "ionic-angular";
import { CreateWeixinLoginPage } from "./create-weixin-login";

@NgModule({
  declarations: [CreateWeixinLoginPage],
  imports: [IonicPageModule.forChild(CreateWeixinLoginPage)],
})
export class CreateWeixinLoginPageModule {}



// WEBPACK FOOTER //
// ./src/pages/create-weixin-login/create-weixin-login.module.ts